import { DirectUpload } from "@rails/activestorage"
import consumer from "channels/consumer"

// ---------------------------------------------------------------------------
// Dropzone AI State Management
// ---------------------------------------------------------------------------
// Centralized helpers for managing the visual states of a dropzone with AI
// photo validation. Each function transitions the dropzone to a single,
// well-defined state — preventing scattered inline mutations.
// ---------------------------------------------------------------------------

var DropzoneAI = {

  // -- State: Validating (spinner + message, Next button blocked) ----------
  setValidating: function(dropzone, fieldset, message) {
    dropzone.addClass('ai-validating')
    dropzone.removeClass('ai-approved ai-corrected ai-rejected ai-cooldown')
    dropzone.find('.dropzone-instructions .ico-upload').hide()
    dropzone.find('.dz-preview').hide()
    dropzone.find('.dz-remove').hide()
    dropzone.find('.status').addClass('uploading').html(
      '<i class="ai-spinner"></i> ' + (message || 'Procesando foto...')
    )
    fieldset.find('.button--next').addClass('disabled')
  },

  // -- State: Approved or Corrected (check + preview + Next enabled) -------
  setApproved: function(dropzone, fieldset, message, opts) {
    opts = opts || {}
    var cssClass = opts.corrected ? 'ai-corrected' : 'ai-approved'
    var iconClass = 'ai-check'

    dropzone.removeClass('ai-validating ai-rejected ai-cooldown')
    dropzone.addClass(cssClass)
    dropzone.find('.status').addClass('uploading').html(
      '<i class="' + iconClass + '"></i> ' + (message || 'Foto aceptada')
    )

    // Show preview and delete button
    dropzone.find('.dz-preview').show()
    dropzone.find('.dz-remove').addClass('button delete small').show()

    // Update image src if corrected and URL provided
    if (opts.corrected && opts.imageUrl) {
      var preview = dropzone.find('.dz-preview img, .dz-image img')
      if (preview.length) {
        preview.attr('src', opts.imageUrl + '?t=' + Date.now())
      }
    }

    MyUploader.checkNextButtonState(fieldset)
  },

  // -- State: Rejected (error + instructions + retry CTA) -----------------
  setRejected: function(dropzone, fieldset, message, instructions) {
    dropzone.removeClass('ai-validating ai-approved ai-corrected ai-cooldown')
    dropzone.addClass('ai-rejected')
    dropzone.find('.dz-preview').hide()
    dropzone.find('.dz-remove').hide()

    var html = '<p><i class="ai-error"></i> ' + (message || 'Fotografía con errores') + '</p>'
    if (instructions) {
      html += '<p class="ai-instructions">' + instructions + '</p>'
    }
    html += '<p class="ai-retry-cta ai-retry-cta--ready">Arrastra o haz click aquí para subir otra foto</p>'

    dropzone.find('.status').addClass('uploading').html(html)
    // Next button stays disabled — user must re-upload
  },

  // -- State: Cooldown (blocked with countdown timer) ----------------------
  // Used by both the JS retry limit (3 failed attempts) and the 429 rate limit.
  startCooldown: function(dropzone, fieldset, seconds, title) {
    dropzone.removeClass('ai-validating ai-approved ai-corrected')
    dropzone.addClass('ai-rejected ai-cooldown')
    dropzone.find('.dz-preview').hide()
    dropzone.find('.dz-remove').hide()

    var statusEl = dropzone.find('.status')
    var remaining = seconds

    var tick = function() {
      if (remaining > 0) {
        statusEl.addClass('uploading').html(
          '<i class="ai-error"></i> <strong>' + title + '</strong>' +
          '<div class="ai-instructions">Podrás intentar de nuevo en ' + remaining + 's</div>'
        )
        remaining--
        setTimeout(tick, 1000)
      } else {
        DropzoneAI.reset(dropzone, fieldset)
      }
    }
    tick()
  },

  // -- State: Reset (return to initial empty upload state) -----------------
  reset: function(dropzone, fieldset) {
    dropzone.removeClass('ai-validating ai-approved ai-corrected ai-rejected ai-cooldown preview-mode')
    dropzone.find('.dz-preview').hide()
    dropzone.find('.dz-remove').hide()
    dropzone.find('.progress-load').css('width', '0%')
    dropzone.find('.dropzone-instructions .ico-upload').show()
    dropzone.find('.status').removeClass('uploading').html(
      'Arrastrar y colocar aquí o <span>buscar</span>'
    )
    dropzone.data('ai-failed', 0)
    dropzone.data('ai-cooldown', false)
    MyUploader.checkNextButtonState(fieldset)
  }
}


// ---------------------------------------------------------------------------
// MyUploader — DirectUpload + AI Photo Validation
// ---------------------------------------------------------------------------

class MyUploader {
  constructor(file, url, dropzone) {

    // Define DOM elements
    this.dropzone_dom = dropzone
    this.dropzone_loader = this.dropzone_dom.find('.progress-load')
    this.dropzone_loader_txt = this.dropzone_dom.find('.status')
    this.dropzone_preview = this.dropzone_dom.find('.dz-preview')
    this.dropzone_remove = this.dropzone_dom.find('.dz-remove')
    this.meta_field = this.dropzone_dom.parents('.form-field').find('input[type="hidden"]')
    this.meta_field_files = [] // used to store the val() of each field

    if (this.dropzone_dom.data('model')) {
      if (this.dropzone_dom.data('model') === "user") {
        this.model = "user[user_real_id][]"
      }
    } else {
      this.model = "application[files][]"
    }

    this.upload = new DirectUpload(file, url, this)
    this.upload.create((error, blob) => {

      if (error) {
        //alert("Hubo un error subiendo tu archivo.")
        this.dropzone_dom.addClass("dropzone-area--has-error")
      } else {
        //console.log(blob)

        // create hidden fields for attachments
        var hiddenField = document.createElement('input')
        hiddenField.setAttribute("type", "hidden")
        hiddenField.setAttribute("value", blob.signed_id)
        hiddenField.name =  this.model
        document.querySelector('form').appendChild(hiddenField)


        //this.meta_field.val(blob.id)
        if ( this.meta_field.val() === '' ) {
          this.meta_field.val(blob.id)
        } else {
          this.meta_field.val( `${this.meta_field.val()}, ${blob.id}` )
        }

        this.meta_field.attr('data-file-blob-id', blob.id)

        // iterate over each [data-file-blob-id] and push the val() to meta_field_files array
        $("[data-file-blob-id]").each(function(i,e) {
          var field_required = $(e).data('blob-required');
          if ( field_required ) {
            this.meta_field_files.push($(e).attr("data-file-blob-id"))
          }
        }.bind(this))

        // AI Photo Validation: trigger if field has ai validation enabled
        if (this.dropzone_dom.data('ai-validation')) {
          // Hide preview until AI approves — enter preview-mode for layout but hide the image
          this.dropzone_dom.addClass('preview-mode')
          this.dropzone_preview.hide()
          this.dropzone_remove.hide()
          this.triggerAiValidation(blob.signed_id, blob.id)
        } else {
          // No AI validation — show preview immediately as before
          this.dropzone_dom.addClass('preview-mode')
          this.dropzone_remove.addClass('button delete small')
          this.dropzone_preview.show()
        }

      }
    })
  }

  triggerAiValidation(signedId, blobId) {
    var fieldId = this.dropzone_dom.data('ai-field-id')
    var dropzone = this.dropzone_dom
    var fieldset = dropzone.parents('.fieldset')

    // Set initial validating state
    DropzoneAI.setValidating(dropzone, fieldset, 'Procesando foto...')

    // Subscribe to ActionCable for this blob
    var subscription = consumer.subscriptions.create(
      { channel: "PhotoValidationChannel", blob_id: blobId },
      {
        received: function(data) {
          // Intermediate states — update spinner text, keep waiting
          if (data.status === "preprocessing" || data.status === "validating" || data.status === "correcting") {
            dropzone.find('.status').html('<i class="ai-spinner"></i> ' + data.message)
            return
          }

          // Clear the frontend timeout — server responded in time
          clearTimeout(aiTimeout)

          // --- Final states ---

          if (data.status === "approved" || data.status === "corrected") {
            DropzoneAI.setApproved(dropzone, fieldset, data.message, {
              corrected: data.status === "corrected",
              imageUrl: data.image_url
            })

          } else if (data.status === "rejected" || data.status === "error") {
            // Track failed attempts for JS-side retry limit
            var failedAttempts = (dropzone.data('ai-failed') || 0) + 1
            dropzone.data('ai-failed', failedAttempts)

            if (failedAttempts >= 3) {
              // 3 strikes — 30s cooldown before allowing re-upload
              DropzoneAI.startCooldown(dropzone, fieldset, 30, 'Fotografía con errores')
            } else {
              DropzoneAI.setRejected(dropzone, fieldset, 'Fotografía con errores', data.instructions)
            }
          }

          subscription.unsubscribe()
        }
      }
    )

    // Frontend timeout: if no ActionCable response in 30s, accept silently.
    // Why 30s: large phone photos (10MB+) need ~7s for MiniMagick preprocess
    // plus ~5s for Bedrock — 12s was too tight and approved before the AI replied.
    var aiTimeout = setTimeout(function() {
      if (dropzone.hasClass('ai-validating')) {
        DropzoneAI.setApproved(dropzone, fieldset, 'Foto aceptada')
        subscription.unsubscribe()
      }
    }, 30000)

    // POST to /validate_photo
    $.ajax({
      url: '/validate_photo',
      method: 'POST',
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      data: { field_id: fieldId, blob_id: signedId },
      dataType: 'json',
      success: function(response) {
        if (response.status === "skipped") {
          clearTimeout(aiTimeout)
          subscription.unsubscribe()
          DropzoneAI.setApproved(dropzone, fieldset, 'Foto aceptada')
        }
        // "processing" status — wait for ActionCable result
      },
      error: function(xhr) {
        clearTimeout(aiTimeout)
        subscription.unsubscribe()

        if (xhr.status === 429) {
          // Rate limited by server — cooldown using Retry-After header
          var retryAfter = parseInt(xhr.getResponseHeader('Retry-After')) || 30
          DropzoneAI.startCooldown(dropzone, fieldset, retryAfter, 'Límite de solicitudes alcanzado')
        } else {
          // Other HTTP errors — accept silently (not user's fault)
          DropzoneAI.setApproved(dropzone, fieldset, 'Foto aceptada')
        }
      }
    })
  }

  // Static method to check if Next button should be re-enabled
  static checkNextButtonState(fieldset) {
    var hasValidating = fieldset.find('.ai-validating').length > 0
    var hasRejected = fieldset.find('.ai-rejected').length > 0
    var hasRequiredEmpty = fieldset.find('.dropzone-area.required').not('.ai-approved, .ai-corrected, .preview-mode').length > 0

    if (!hasValidating && !hasRejected && !hasRequiredEmpty) {
      fieldset.find('.button--next').removeClass('disabled')
    }
  }

  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener("progress",
      event => this.directUploadDidProgress(event))
  }

  directUploadDidProgress(event) {
    var progress = Math.round((event.loaded * 100) / event.total)
    this.dropzone_loader.css('width', progress + '%')
    this.dropzone_loader_txt.addClass('uploading')
    this.dropzone_loader_txt.html(`Subiendo documento: <strong>${progress}%</strong>`)
  }
}

export default MyUploader;
